import React from 'react'
import FormControl from '@mui/material/FormControl'
import Grid from '@mui/material/Grid'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'

const InitialRhythm = ({ moduleValues, setModuleValues }) => (
  <Grid item xs={12} lg={4}>
    <FormControl fullWidth>
      <InputLabel>Initial Rhythm</InputLabel>
      <Select
        value={moduleValues?.['Initial Rhythm'] ?? ''}
        label="Initial Rhythm"
        onChange={(e) =>
          setModuleValues((prev) => ({
            ...prev,
            ['Initial Rhythm']: e.target.value,
          }))
        }
      >
        {[
          'Asystole',
          'VF (Ventricular Fibrillation)',
          'PEA (Pulseless Electrical Activity)',
          'VT (Ventricular Tachycardia)',
        ].map((x) => (
          <MenuItem key={x} value={x}>
            {x}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </Grid>
)

export default InitialRhythm
